import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MangaCard from "@/components/feature/MangaCard";
import { mangas, categories, banners, reviews, siteInfo } from "@/mocks/manga";

export default function Home() {
  const [currentBanner, setCurrentBanner] = useState(0);
  const [activeCategory, setActiveCategory] = useState("all");

  useEffect(() => {
    document.title = "九妖漫画网 - 免费漫画全集大全免费下拉式追更 | 好看的国漫推荐日漫精选韩漫热门";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", siteInfo.description);
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute("content", "九妖漫画网,免费漫画,免费全集,免费下拉式,免费追更,免费在线阅读,好看的漫画,国漫推荐,日漫精选,韩漫热门,漫画大全,下拉式漫画");
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const filteredMangas = activeCategory === "all"
    ? mangas
    : mangas.filter((m) => m.category === activeCategory || m.subcategory === activeCategory);

  const hotMangas = [...mangas].sort((a, b) => b.rating - a.rating).slice(0, 8);
  const latestMangas = [...mangas].sort((a, b) => {
    if (a.updateTime.includes("今天") && !b.updateTime.includes("今天")) return -1;
    if (!a.updateTime.includes("今天") && b.updateTime.includes("今天")) return 1;
    return 0;
  }).slice(0, 6);
  const rankMangas = [...mangas].sort((a, b) => b.rating - a.rating).slice(0, 10);

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    url: "https://www.jiuyaomh.com",
    description: siteInfo.description,
    contactPoint: {
      "@type": "ContactPoint",
      email: siteInfo.email,
      contactType: "customer service",
    },
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.name,
    url: "https://www.jiuyaomh.com",
    description: siteInfo.description,
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.jiuyaomh.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "九妖漫画网提供哪些类型的漫画？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "九妖漫画网提供国漫推荐、日漫精选、韩漫热门等多种类型的免费漫画，涵盖热血、恋爱、玄幻、科幻、悬疑、搞笑等丰富分类。",
        },
      },
      {
        "@type": "Question",
        name: "九妖漫画网的漫画是免费的吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "是的，九妖漫画网的全部漫画均为免费阅读，采用免费下拉式追更模式，无需付费即可畅享完整漫画内容。",
        },
      },
      {
        "@type": "Question",
        name: "如何在九妖漫画网阅读漫画？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "用户只需访问九妖漫画网，选择喜欢的漫画作品，即可通过免费下拉式阅读方式在线观看漫画全集，无需注册或下载。",
        },
      },
      {
        "@type": "Question",
        name: "九妖漫画网支持哪些设备？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "九妖漫画网支持电脑、平板和手机等多种设备，用户可以在任何设备上流畅地免费在线阅读漫画。",
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            {banners.map((banner, index) => (
              <Link
                key={banner.id}
                to={banner.link}
                className={`absolute inset-0 transition-opacity duration-700 cursor-pointer ${
                  index === currentBanner ? "opacity-100 z-10" : "opacity-0 z-0"
                }`}
              >
                <img
                  src={banner.image}
                  alt={banner.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50" />
              </Link>
            ))}

            <div className="absolute inset-0 z-20 flex flex-col items-center justify-center px-4">
              <div className="w-full text-center">
                <h1 className="text-3xl md:text-5xl font-heading font-black text-white mb-4 tracking-tight">
                  {siteInfo.name}
                </h1>
                <p className="text-base md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                  {siteInfo.slogan}
                </p>
                <div className="max-w-xl mx-auto relative">
                  <input
                    type="text"
                    placeholder="搜索你喜欢的漫画..."
                    className="w-full px-5 py-3.5 pr-12 rounded-full text-sm bg-white/95 text-foreground-800 placeholder:text-foreground-400 outline-none"
                  />
                  <button className="absolute right-1.5 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                    <i className="ri-search-line" />
                  </button>
                </div>
                <div className="flex flex-wrap gap-2 justify-center mt-5">
                  {["斗破苍穹", "我独自升级", "咒术回战", "一人之下", "鬼灭之刃"].map((tag) => (
                    <Link
                      key={tag}
                      to={`/manga/${mangas.find((m) => m.title === tag)?.id || 1}`}
                      className="text-xs text-white/80 bg-white/15 hover:bg-white/25 px-3 py-1 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
              {banners.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentBanner(i)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    i === currentBanner ? "bg-primary-500 w-7" : "bg-white/60 hover:bg-white/80"
                  }`}
                />
              ))}
            </div>
          </section>

          {/* Category Navigation */}
          <section className="bg-background-100 border-b border-background-200/70">
            <div className="px-4 md:px-6 py-4">
              <div className="flex flex-wrap items-center gap-2">
                {categories.filter((c) => ["all", "guoman", "riman", "hanman", "rexue", "lianai", "gaoxiao", "xuanhuan"].includes(c.slug)).map((cat) => (
                  <button
                    key={cat.slug}
                    onClick={() => setActiveCategory(cat.slug)}
                    className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeCategory === cat.slug
                        ? "bg-primary-500 text-white"
                        : "bg-background-50 text-foreground-700 hover:bg-primary-50 hover:text-primary-500"
                    }`}
                  >
                    <i className={`${cat.icon} text-base`} />
                    {cat.name}
                  </button>
                ))}
                <Link
                  to="/category/all"
                  className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 ml-auto whitespace-nowrap cursor-pointer"
                >
                  全部分类 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </section>

          {/* Hot Recommendations */}
          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩漫画</p>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                查看更多 <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {hotMangas.map((manga) => (
                <MangaCard key={manga.id} {...manga} tags={manga.tags} />
              ))}
            </div>
          </section>

          {/* Stats Bar */}
          <section className="bg-background-100 border-y border-background-200/70">
            <div className="px-4 md:px-6 py-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                {[
                  { value: "15,000+", label: "漫画资源", icon: "ri-book-open-line" },
                  { value: "500万+", label: "日活跃用户", icon: "ri-user-line" },
                  { value: "99.9%", label: "服务稳定性", icon: "ri-shield-check-line" },
                  { value: "8年", label: "运营经验", icon: "ri-history-line" },
                ].map((stat) => (
                  <div key={stat.label}>
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className={`${stat.icon} text-lg`} />
                    </div>
                    <div className="text-xl md:text-2xl font-heading font-bold text-foreground-900">{stat.value}</div>
                    <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Updates + Ranking */}
          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                      最近更新
                    </h2>
                    <p className="text-sm text-foreground-500 mt-1">实时追踪最新漫画章节</p>
                  </div>
                </div>
                <div className="space-y-4">
                  {latestMangas.map((manga) => (
                    <Link
                      key={manga.id}
                      to={`/manga/${manga.id}`}
                      className="flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-100 border border-background-200/70 transition-colors duration-200 cursor-pointer group"
                    >
                      <div className="w-16 h-20 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                        <img
                          src={manga.cover}
                          alt={manga.title}
                          title={`${manga.title} - 免费下拉式漫画`}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                          {manga.title}
                        </h3>
                        <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
                        <div className="flex flex-wrap items-center gap-2 mt-2">
                          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full">
                            {manga.updateChapter}
                          </span>
                          <span className="text-xs text-foreground-400">{manga.updateTime}</span>
                        </div>
                      </div>
                      <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors duration-200">
                        <i className="ri-arrow-right-s-line" />
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              <div className="lg:w-80">
                <div className="bg-background-100 rounded-lg p-5 border border-background-200/70 sticky top-20">
                  <div className="flex items-center gap-2 mb-5">
                    <i className="ri-fire-line text-accent-500 text-lg" />
                    <h3 className="font-heading text-base font-bold text-foreground-900">人气排行</h3>
                  </div>
                  <div className="space-y-0">
                    {rankMangas.map((manga, index) => (
                      <Link
                        key={manga.id}
                        to={`/manga/${manga.id}`}
                        className="flex items-center gap-3 py-3 border-b border-background-200/70 last:border-0 hover:bg-background-50 -mx-2 px-2 rounded transition-colors duration-200 cursor-pointer group"
                      >
                        <span
                          className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                            index < 3
                              ? "bg-primary-500 text-white"
                              : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          {index + 1}
                        </span>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                            {manga.title}
                          </p>
                          <p className="text-xs text-foreground-500">{manga.author}</p>
                        </div>
                        <span className="text-xs text-accent-500 font-semibold flex-shrink-0">{manga.rating}分</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* User Reviews */}
          <section className="bg-background-100 border-t border-background-200/70">
            <div className="px-4 md:px-6 py-10 md:py-14">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  漫友评价
                </h2>
                <p className="text-sm text-foreground-500 mt-2">看看漫画爱好者们怎么说</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {reviews.map((review) => (
                  <div
                    key={review.id}
                    className="bg-background-50 rounded-lg p-5 border border-background-200/70"
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                        <img
                          src={review.avatar}
                          alt={review.user}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-800">{review.user}</p>
                        <div className="flex gap-0.5 mt-0.5">
                          {Array.from({ length: review.rating }).map((_, i) => (
                            <i key={i} className="ri-star-fill text-xs text-accent-500" />
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                    <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-500 mt-2">关于九妖漫画网的常见疑问解答</p>
              </div>
              <div className="space-y-3">
                {faqSchema.mainEntity.map((faq, i) => (
                  <details
                    key={i}
                    className="bg-background-100 rounded-lg border border-background-200/70 group"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                      <h4 className="text-sm font-medium text-foreground-800 pr-4">
                        <a href={`#faq-${i}`} className="text-inherit no-underline">{faq.name}</a>
                      </h4>
                      <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0" />
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0" />
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.acceptedAnswer.text}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20beautiful%20warm-toned%20illustration%20of%20a%20cozy%20reading%20corner%20with%20manga%20books%20and%20soft%20lighting%2C%20comfortable%20atmosphere%2C%20stylized%20anime-inspired%20art%2C%20inviting%20warm%20glow%2C%20clean%20composition&width=1600&height=500&seq=cta-bg-home&orientation=landscape"
              alt="开始阅读漫画"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center px-4 text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
                立即开启免费漫画之旅
              </h2>
              <p className="text-sm md:text-base text-white/80 mb-6 max-w-lg">
                海量漫画免费看，下拉式追更超畅快，就在九妖漫画网
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line" /> 开始阅读
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}